{
    "NewuserWelcomereporting": "Benvenuti in Akixi Reporting",
    "NewuserWelcometoreporting": "Benvenuti nel Reporting",
    "NewuserLetsbegin": "Cominciamo.",
    "NewuserStartTutorial": "Avvio del tutorial",
    "NewuserSkiptutorial": "Saltare l'esercitazione",
    "NewuserAddmodifyreport": "Aggiungere\/modificare i rapporti...",
    "NewuserReportfiltering": "Filtraggio dei rapporti...",
    "NewuserAddingfields": "Aggiunta di campi...",
    "NewuserReportquickchanges": "Segnalazione di modifiche rapide...",
    "NewuserFinish": "Finitura",
    "NewuserNext": "Avanti",
    "NewuserPrevious": "Precedente",
    "NAME": "LanguageNewUserTutorial"
}